/**
 * MM Popup - Gestion de la popup d'ajout au panier
 * Fonctionnalités :
 * - Affichage de la popup depuis product cards et pages produit
 * - Chargement des produits complémentaires
 * - Gestion des événements d'ajout au panier
 * - Accessibilité et navigation clavier
 */

// Variables globales pour la popup
let popup, closeBtn, continueBtn;

/**
 * Fonction pour ajouter au panier ET ouvrir la popup (nouvelle version)
 * @param {HTMLElement} button - Bouton qui a déclenché l'action
 */
window.addToCartAndShowPopup = function(button) {
    const productHandle = button.dataset.productHandle;

    if (!productHandle) {
        console.error('Product handle non trouvé');
        return;
    }

    // Récupérer les données du produit depuis la card
    const card = button.closest('.product-card, .js-product-card');
    const variantInput = card?.querySelector('input[name="id"]');
    const ceramicInput = card?.querySelector('input[name="properties[_isCeramicProduct]"]');

    if (!variantInput) {
        console.error('Variant ID non trouvé');
        return;
    }

    const data = {
        id: variantInput.value,
        quantity: 1,
        properties: {
            '_isCeramicProduct': ceramicInput ? ceramicInput.value : 'false'
        }
    };

    // Ajouter au panier
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(data => {
        if (data) {
            // Mettre à jour le compteur du panier
            if (typeof updateCartCount === 'function') {
                    fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                        updateCartCount(cart.item_count);
                    })
                    .catch(err => console.error('Erreur lors de la récupération du panier:', err));
            }

            // Ouvrir la popup avec les produits complémentaires
            mmShowPopupProduct(button);
        }
    })
    .catch(error => {
        console.error('Erreur lors de l\'ajout au panier:', error);
    });
};

/**
 * Fonction pour ajouter au panier ET ouvrir la popup (compatible avec l'ancien système)
 * @param {HTMLElement} button - Bouton qui a déclenché l'action
 */
window.handleProductCardAddToCart = function(button) {
    let productHandle = button.dataset.productHandle;

    if (!productHandle) {
        // Essayer de récupérer le handle depuis l'URL ou d'autres sources
        const card = button.closest('.product-card, .js-product-card');
        const productLink = card?.querySelector('a[href*="/products/"]');
        if (productLink) {
            const href = productLink.getAttribute('href');
            const match = href.match(/\/products\/([^\/\?]+)/);
            if (match) {
                productHandle = match[1];
            }
        }
    }

    if (!productHandle) {
        console.error('Product handle non trouvé');
        return;
    }

    // Récupérer les données du produit depuis la card
    const card = button.closest('.product-card, .js-product-card');
    const variantInput = card?.querySelector('input[name="id"]');
    const ceramicInput = card?.querySelector('input[name="properties[_isCeramicProduct]"]');

    if (!variantInput) {
        console.error('Variant ID non trouvé');
        return;
    }

     // Ouvrir la popup avec les produits complémentaires
    const tempButton = document.createElement('button');
    tempButton.dataset.productHandle = productHandle;
    mmShowPopupProduct(tempButton);
    /**
    * CODE COMMENTÉ - Ne pas utiliser
    *   
    * Cette fonction causait le problème de double ajout au panier.
    * La fonctionnalité d'ajout au panier est maintenant gérée par la fonction
    * addToCartAndShowPopup() qui affiche également la popup de confirmation.
    * 
    * Ce code dupliqué a été désactivé le [23rd Dec 2025] pour résoudre le problème
    * où les produits étaient ajoutés deux fois au panier lors du clic sur
    * le bouton "Ajout rapide".
    * 
    * À FAIRE : Supprimer définitivement ce code après confirmation que la
    * correction fonctionne correctement en production.
    */
    /*
    const data = {
        id: variantInput.value,
        quantity: 1,
        properties: {
            '_isCeramicProduct': ceramicInput ? ceramicInput.value : 'false'
        }
    };

    // Ajouter au panier
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(data => {
        if (data) {
            // Mettre à jour le compteur du panier
            if (typeof updateCartCount === 'function') {
                   fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                        updateCartCount(cart.item_count);
                    })
                    .catch(err => console.error('Erreur lors de la récupération du panier:', err));
            }

            // Ouvrir la popup avec les produits complémentaires
            const tempButton = document.createElement('button');
            tempButton.dataset.productHandle = productHandle;
            mmShowPopupProduct(tempButton);
        }
    })
    .catch(error => {
        console.error('Erreur lors de l\'ajout au panier:', error);
    });
    */
};

        /**
         * Fonction globale pour afficher la popup d'ajout au panier
         * @param {HTMLElement} button - Bouton qui a déclenché l'ouverture
         */
        function mmShowPopupProduct(button) {
            console.log('Popup demandée');

            // Récupérer le handle du produit
            const productHandle = button.dataset.productHandle;

            if (!productHandle) {
                console.error('Product handle non trouvé');
                return;
            }

            // Charger le contenu de la popup via l'API
            fetch(`/products/${productHandle}?view=popup`)
                .then(res => res.text())
                .then(html => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;

                    // Récupérer le contenu de la popup
                    const popupContent = tempDiv.querySelector('[data-product-popup]');

                    if (popupContent) {
                        // Supprimer l'ancienne popup si elle existe
                        const existingPopup = document.querySelector('[data-product-popup]');
                        if (existingPopup) {
                            existingPopup.remove();
                        }

                        // Ajouter la nouvelle popup au body
                        document.body.appendChild(popupContent);

                        // Mettre à jour les variables globales
                        popup = popupContent;
                        closeBtn = popup.querySelector('[data-product-popup-close]');
                        continueBtn = popup.querySelector('[data-product-popup-continue]');

                        // Réattacher les événements
                        attachPopupEvents();

                        // Ouvrir la popup
                        openPopup();
                    } else {
                        console.error('Contenu de popup non trouvé dans la réponse');
                    }
                })
                .catch(error => {
                    console.error('Erreur lors du chargement de la popup:', error);
                });
        }

/**
 * Fonction pour charger les produits complémentaires
 * Maintenant géré côté serveur via Liquid - cette fonction ne fait plus rien
 */
async function loadComplementaryProducts() {
    // Les produits complémentaires sont maintenant chargés côté serveur via Liquid
    // avec le metafield ProductListDrop
    console.log('Produits complémentaires chargés côté serveur via Liquid');
}

/**
 * Fonction pour attacher les événements aux formulaires de produits complémentaires
 */
function attachComplementaryProductEvents() {
    const accessoryButtons = document.querySelectorAll('[data-accessory-btn]');

    accessoryButtons.forEach(button => {
        const form = button.closest('form');
        if (form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                // Désactiver le bouton pendant l'ajout
                button.disabled = true;

                const formData = new FormData(form);

                fetch('/cart/add.js', {
                   method: 'POST',
                   body: formData
               })
               .then(response => response.json())
               .then(data => {
                   // Changer le texte du bouton pour afficher seulement "Ajouté !"
                   const addedText = button.dataset.addedText;
                   button.innerHTML = addedText;

                   // Mettre à jour le compteur du panier
                   if (typeof updateCartCount === 'function') {
                                    fetch('/cart.js')
                           .then(res => res.json())
                           .then(cart => {
                               updateCartCount(cart.item_count);
                           })
                           .catch(err => console.error('Erreur lors de la récupération du panier:', err));
                   }
               })
               .catch(error => {
                   console.error('Erreur lors de l\'ajout au panier:', error);
                   button.disabled = false;
               });
            });
        }
    });
}

/**
 * Fonction globale pour ouvrir la popup
 */
window.openPopup = function() {
    if (!popup) {
        console.error('Popup non trouvée');
        return;
    }

    // Gérer l'accessibilité
    popup.setAttribute('aria-hidden', 'false');
    popup.style.display = 'flex';

    // Désactiver le focus sur les éléments en dehors de la popup
    const focusableElements = document.querySelectorAll('a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
    focusableElements.forEach(el => {
        if (!popup.contains(el) && !el.closest('.mm-cart') && !el.closest('.mm-drawer-cart')) {
            el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') || '0');
            el.setAttribute('tabindex', '-1');
        }
    });

    setTimeout(() => {
        popup.classList.add('show');
        // Focus sur le premier élément focusable de la popup
        const firstFocusable = popup.querySelector('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
            firstFocusable.focus();
        }
    }, 10);
    document.body.style.overflow = 'hidden';
};

/**
 * Fonction globale pour fermer la popup
 */
window.closePopup = function() {
    if (!popup) {
        console.error('Popup non trouvée');
        return;
    }

    // Gérer l'accessibilité
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('show');

    // Restaurer le focus sur les éléments en dehors de la popup
    const elementsWithOriginalTabindex = document.querySelectorAll('[data-original-tabindex]');
    elementsWithOriginalTabindex.forEach(el => {
        const originalTabindex = el.getAttribute('data-original-tabindex');
        if (originalTabindex === '0') {
            el.removeAttribute('tabindex');
        } else {
            el.setAttribute('tabindex', originalTabindex);
        }
        el.removeAttribute('data-original-tabindex');
    });

    document.body.style.overflow = '';

    // Supprimer la popup du DOM après l'animation
    setTimeout(() => {
        if (popup && popup.parentNode) {
            popup.remove();
        }
        // Réinitialiser les variables globales
        popup = null;
        closeBtn = null;
        continueBtn = null;
    }, 300);
};

/**
 * Fonction pour réattacher les événements après le chargement dynamique
 */
function attachPopupEvents() {
    const closeBtn = document.querySelector('[data-product-popup-close]');
    const continueBtn = document.querySelector('[data-product-popup-continue]');
    const popup = document.querySelector('[data-product-popup]');

    // Fermer la popup
    if (closeBtn) {
        closeBtn.removeEventListener('click', closePopup);
        closeBtn.addEventListener('click', closePopup);
    }

    if (continueBtn) {
        continueBtn.removeEventListener('click', closePopup);
        continueBtn.addEventListener('click', closePopup);
    }

    // Fermer en cliquant sur l'overlay
    if (popup) {
        popup.removeEventListener('click', handleOverlayClick);
        popup.addEventListener('click', handleOverlayClick);
    }

    // Réattacher les événements des boutons d'accessoires
    attachComplementaryProductEvents();
}

/**
 * Fonction pour gérer le clic sur l'overlay
 * @param {Event} e - Événement de clic
 */
function handleOverlayClick(e) {
    if (e.target === e.currentTarget) {
        closePopup();
    }
}

/**
 * Initialisation au chargement de la page
 */
document.addEventListener('DOMContentLoaded', function() {
    // Gérer les soumissions de formulaires d'ajout au panier
    const popupTriggers = document.querySelectorAll('[data-product-popup-trigger]');

    popupTriggers.forEach(trigger => {
        const form = trigger.closest('form');
        if (form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault(); // Empêcher la soumission normale qui ouvrirait le cart

                // Effectuer l'ajout au panier via AJAX
                const formData = new FormData(form);

                fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {

                      // Mettre à jour le compteur du panier avec le nombre total d'items
                    if (typeof updateCartCount === 'function') {
                        fetch('/cart.js')
                            .then(res => res.json())
                            .then(cart => {
                                updateCartCount(cart.item_count);
                            })
                            .catch(err => console.error('Erreur lors de la récupération du panier:', err));
                    }
                    // Produit ajouté avec succès, ouvrir la popup
                    // Pour les formulaires, on utilise le produit de la page actuelle
                    const productHandle = window.location.pathname.includes('/products/') ?
                        window.location.pathname.split('/products/')[1].split('?')[0] : null;

                    if (productHandle) {
                        // Créer un bouton temporaire pour déclencher la popup
                        const tempButton = document.createElement('button');
                        tempButton.dataset.productHandle = productHandle;
                        mmShowPopupProduct(tempButton);
                    } else {
                        console.error('Handle du produit non trouvé pour la popup');
                    }

                    // Mettre à jour le compteur du panier si disponible
                    if (typeof updateCartCount === 'function') {
                        updateCartCount();
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de l\'ajout au panier:', error);
                    // En cas d'erreur, soumettre le formulaire normalement
                    form.submit();
                });
            });
        }
    });

    // Écouter les événements personnalisés pour les product-cards
    document.addEventListener('cartItemAdded', function(e) {
        console.log('Événement cartItemAdded reçu:', e.detail);
        if (e.detail && e.detail.source === 'product-card') {
            console.log('Ouverture de la popup depuis product-card via événement');
            // Pour les événements, on utilise le produit de la page actuelle
            const productHandle = window.location.pathname.includes('/products/') ?
                window.location.pathname.split('/products/')[1].split('?')[0] : null;

            if (productHandle) {
                const tempButton = document.createElement('button');
                tempButton.dataset.productHandle = productHandle;
                mmShowPopupProduct(tempButton);
            }
        }
    });

    // Fermer avec la touche Escape et gérer le focus trap
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup && popup.classList.contains('show')) {
            closePopup();
        }

        // Focus trap - garder le focus dans la popup
        if (popup && popup.classList.contains('show') && e.key === 'Tab') {
            const focusableElements = popup.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else {
                // Tab
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }
    });
});
